import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data": []
}
const blockedContact = createSlice({
    name:'blockedContact',
    initialState,
    reducers:{
        addBlockedContact: (_state,payload)=>{
            return {
                ..._state,
                "id" : uuidv4(),
                "data": payload.payload
            }
        }
    }
});

export default blockedContact.reducer
export const addBlockedContact = blockedContact.actions.addBlockedContact